"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRStPlAuthUrl = void 0;
const url_utils_1 = require("./url.utils");
class XHRStPlAuthUrl {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        const isSSSEnabled = (0, url_utils_1.isSSSEnvironment)();
        XHRStPlAuthUrl.AUTH_PATHS.some(({ origin, toReplace }) => {
            if (request.url.includes(origin)) {
                const authToUse = isSSSEnabled ? toReplace.SSSEnabled : toReplace.SSSDisabled;
                request.url = request.url.replace(origin, authToUse);
                return true;
            }
            return false;
        });
        return Promise.resolve(request);
    }
}
XHRStPlAuthUrl.AUTH_PATHS = [
    {
        origin: 'mb-api-auth',
        toReplace: {
            SSSEnabled: 'st-api-auth',
            SSSDisabled: 'st-api-poc-mex-sss',
        },
    },
    {
        origin: 'st-api-sss-authr',
        toReplace: {
            SSSEnabled: 'st-api-sss-authr',
            SSSDisabled: 'st-api-poc-mex-sss',
        },
    },
];
exports.XHRStPlAuthUrl = XHRStPlAuthUrl;
//# sourceMappingURL=xhrStPlAuthUrl.js.map